import { useEffect } from 'react';

const { BodyScrollManager } = window;

export default (scrollableRef) => {
  useEffect(() => {
    const { current } = scrollableRef;
    BodyScrollManager.disable(current);
    return () => {
      BodyScrollManager.enable(current);
    };
  }, []);
};
